import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';

const FacetValue = ({ facetCode, value, isLast, onApplyFilter }) => {
  const { t } = useTranslation();
  const isColor = facetCode === 'baseColor';
  const { name, style } = isColor ? calculateFilterColor(value.code) : {};

  return (
    <button
      className={`ken-plp__filters__facet-value ${
        value.selected ? ' --selected' : ''
      }${isLast ? ' --last' : ''}`}
      type='button'
      onClick={() => onApplyFilter(value.query)}
    >
      {isColor && <i className='--color' style={style} />}
      {facetCode === 'percentageDiscountValue'
        ? t('listing:filter.option.discount.range', {
            range: value.name,
          })
        : name || value.name || value.code}
      &nbsp;({value.count})
    </button>
  );
};

FacetValue.propTypes = {
  facetCode: PropTypes.string,
  value: PropTypes.shape(),
  isLast: PropTypes.bool,
  onApplyFilter: PropTypes.func.isRequired,
};

FacetValue.defaultProps = {
  facetCode: null,
  value: {},
  isLast: false,
};

export default FacetValue;
